<template>
  <div class="help-center-footer-notice-legal__component">
    <HelpCenterIcon
      name="gleamColored"
      size-units="8"
      class="help-center-footer-notice-legal__icon"
    />
    <p>
      <span>©&nbsp;{{ currentYear }}&nbsp;</span>
      <a
        class="help-center-footer-notice-legal__link"
        href="https://abr.business.gov.au/AbnHistory/View?id=31136782191"
      >
        Crowd9 PTY LTD
      </a>
    </p>
    <p>
      All rights reserved
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import HelpCenterIcon from 'help-center/components/HelpCenterIcon'

const currentYear = computed(() => {
  return new Date().getFullYear()
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-footer-notice-legal {
  &__component {
    @include help-center-font(14);
    text-align: right;
    color: var(--help-center-muted);
  }

  &__icon {
    margin-bottom: 12px;
  }

  &__link {
    @include help-center-highlight-link($offset: 2px);
    display: inline-block;
  }
}
</style>
